import {
  RequestMethod,
  AuthType,
  BodyType,
  BodyContentType,
  SourceType,
  ServerVariableExpiryOption,
  ResponseMode,
} from "../constants/restRequestConstants";

export const RequestMethodOptions = Object.values(RequestMethod);

export const AuthTypeOptions = [
  { value: AuthType.NONE, label: "No Authentication" },
  { value: AuthType.USER_TOKEN, label: "Signed-in User Token" },
  { value: AuthType.BASIC, label: "Basic Authentication" },
  { value: AuthType.BEARER, label: "Bearer Token" },
  { value: AuthType.OAUTH2, label: "OAuth 2.0" },
  { value: AuthType.API_KEY, label: "API Key" },
];

export const AddToListOptions = [
  { value: "header", label: "Header" },
  { value: "query", label: "Query Parameter" },
];

export const CommonHeaderOptions = [
  {
    key: "Content-Type",
    value: BodyContentType.JSON,
    label: `Content-Type: ${BodyContentType.JSON}`,
  },
  {
    key: "Accept",
    value: BodyContentType.JSON,
    label: `Accept: ${BodyContentType.JSON}`,
  },
  {
    key: "User-Agent",
    value: "YourApp/1.0",
    label: "User-Agent",
  },
];

export const CommonQueryParamOptions = [
  { key: "page", value: "1", label: "page=1" },
  { key: "limit", value: "10", label: "limit=10" },
  { key: "sort", value: "desc", label: "sort=desc" },
];

export const BodyTypeOptions = [
  { value: BodyType.NONE, label: "None" },
  { value: BodyType.RAW, label: "Raw" },
  { value: BodyType.FORM, label: "Form URL Encoded" },
  { value: BodyType.MULTIPART, label: "Multipart Form Data" },
];

export const ContentFormatOptions = [
  { value: BodyContentType.JSON, label: 'JSON' },
  { value: BodyContentType.TEXT, label: 'Plain Text' },
  { value: BodyContentType.XML, label: 'XML' },
  { value: BodyContentType.HTML, label: 'HTML' },
  { value: BodyContentType.JAVASCRIPT, label: 'JavaScript' },
];

export const SourceTypeOptions = [
  { value: SourceType.FIXED, label: 'Fixed Value' },
  { value: SourceType.FIELD, label: 'Form Field' },
  { value: SourceType.CREDENTIAL, label: 'Credential' },
  { value: SourceType.SERVER_VARIABLE, label: 'Server Variable' },
];

export const MappingSourceTypeOptions = [
  { value: SourceType.FIELD, label: 'Form Field' },
  { value: SourceType.SERVER_VARIABLE, label: 'Server Variable' },
];

export const ServerVariableExpiryOptions = [
  { value: ServerVariableExpiryOption.ONE_MINUTE, label: '1 Minute' },
  { value: ServerVariableExpiryOption.FIVE_MINUTES, label: '5 Minutes' },
  { value: ServerVariableExpiryOption.TEN_MINUTES, label: '10 Minutes' },
  { value: ServerVariableExpiryOption.FIFTEEN_MINUTES, label: '15 Minutes' },
  { value: ServerVariableExpiryOption.THIRTY_MINUTES, label: '30 Minutes' },
  { value: ServerVariableExpiryOption.ONE_HOUR, label: '1 Hour' },
];

export const ResponseModeOptions = [
  { value: ResponseMode.STANDARD, label: 'Standard', description: 'Returns the original response but with mapped response paths replaced with server variable names instead of actual values.' },
  { value: ResponseMode.TEST, label: 'Test', description: 'Returns the original response exactly as received from the API without any modifications or variable substitutions.' },
  { value: ResponseMode.SECURE, label: 'Secure', description: 'Mapped response paths are replaced with server variable names, and all unmapped paths are redacted for security purposes.' },
];

export const FormDataSourceTypeOptions = [
  ...SourceTypeOptions,
  { value: SourceType.ATTACHMENT, label: 'Attachment' },
];


// We can add more later if needed
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/MIME_types/Common_types
// https://www.iana.org/assignments/media-types/media-types.xhtml
// https://svn.apache.org/repos/asf/httpd/httpd/trunk/docs/conf/mime.types
export const CommonContentTypeOptions = [
  { value: BodyContentType.TEXT, label: BodyContentType.TEXT },
  { value: 'application/pdf', label: 'application/pdf' },
  { value: 'image/jpeg', label: 'image/jpeg' },
  { value: 'image/png', label: 'image/png' },
  { value: 'image/gif', label: 'image/gif' },
  { value: 'image/webp', label: 'image/webp' },
  { vaue: 'text/csv', label: 'text/csv' },
  { value: 'application/vnd.ms-excel', label: 'application/vnd.ms-excel' },
  { value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', label: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
  { value: BodyContentType.JSON, label: BodyContentType.JSON },
  { value: BodyContentType.XML, label: BodyContentType.XML },
  { value: BodyContentType.HTML, label: BodyContentType.HTML },
  { value: BodyContentType.FORM, label: BodyContentType.FORM },
  { value: BodyContentType.MULTIPART, label: BodyContentType.MULTIPART },
  { value: 'application/zip', label: 'application/zip' },
  { value: BodyContentType.JAVASCRIPT, label: BodyContentType.JAVASCRIPT },
  { value: BodyContentType.OCTET_STREAM, label: BodyContentType.OCTET_STREAM },
];
